import { makeCommonStore, FormField } from '../commons'
import ProdServiceService from '@/services/ProdServiceService'

const store = {
  ...makeCommonStore(
    {
      service: ProdServiceService,
      fields: [
        new FormField({
          name: 'id',
          hidden: true
        }),
        new FormField({
          name: 'name',
          label: 'Product/service name *',
          icon: 'description',
          rules: [ 'required' ],
          md: 12
        }),
        new FormField({
          name: 'price',
          label: 'Price *',
          rules: [ 'required', 'amount' ],
          text: ''
        }),
        new FormField({
          name: 'gst_percent',
          type: 'select',
          items: [
            { text: '15%', value: 15 },
            { text: '100%', value: 100 },
            { text: 'Zero', value: 0 }
          ],
          label: 'GST(%)',
          rules: [ 'required' ],
          icon: 'payment'
        }),
        new FormField({
          name: 'description',
          label: 'Description',
          icon: 'description',
          rules: [ 'required' ],
          md: 12
        })
      ]
    },
    ['fields']
  ),
  namespaced: true
}

export default store
